const url = process.env.REACT_APP_API_URL;

export const Constants = {
    url: url,
    baseUrl: url + "/api/admin",
};
